import React from 'react';

// Libraries
import classNames from 'classnames';
import { ReactSVG } from 'react-svg';

// Components
import { Layout } from '@/Components';

// Variants
import Variants from './Variants';

// Spec
import * as Spec from './Spec';

// Styles
import './Styles.scss';

const CLASS_NAME = 'loci--icons--logo';

type LogoProps = Spec.Props;

const TITLE = 'Loci';

const Logo: React.FunctionComponent<LogoProps> = ({
  className: _className = '',
  inline,
  variant = 'name',
}) => {
  const className = classNames(
    CLASS_NAME,
    {
      [`${CLASS_NAME}--variant--${variant}`]: variant,
      'loci-layout--inline': inline,
    },
    _className
  );

  const src = Variants[variant];

  return (
    <Layout alignContent='center' justifyItems='center'>
      <ReactSVG
        aria-label={TITLE}
        className={className}
        src={src}
        title={variant === 'name' ? TITLE : ''}
        wrapper='span'
      />
    </Layout>
  );
};

export { type LogoProps, Variants };
export default Logo;
